export async function loadParticlesAttractInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesAttract", async (container) => {
        const { Attractor } = await import("./Attractor.js");
        return new Attractor(container);
    }, refresh);
}
